import React, { Component } from 'react';
import { BrowserRouter as Router, Route,Switch} from "react-router-dom";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import './App.css';
import './styles/reset.css';
import Report from "./views/report/Report"
import Login from "./views/Login"
import Record from "./views/Record"
import Download from "./views/Dowload"
import PersonRegist from "./views/person/PersonRegist"
import PersonCenter from  "./views/person/PersonCenter"
import QuestionList from "./views/person/QuestionList"
import QuestionDetail from "./views/person/QuestionDetail"
import Reward from "./views/person/reward/Reward"
import MessageList from "./views/person/message/MessageList"
import MessageDetail from "./views/person/message/MessageDetail"
import DeviceInfomation from "./views/person/DeviceInfomation"
import ShowResult from  "./views/person/ShowResult"
import FaultPost from  "./views/person/FaultPost"
import Suggestion from "./views/person/Suggestion"
import Devicebuy from  "./views/person/reward/devicebuy"
import RewardJs from  "./views/person/reward/rewardjs"
import store from    "./store/store"
import Shop from   "./views/person/pay/shop"
import Advert from './views/advert/Advert'
import { Provider } from 'mobx-react'
import ReportCar from './views/report/ReportCar'

class App extends Component {
  constructor(props){
    super();
  }

  render() {
    return (
      <Provider store={store}>
      <Router>
        <div>          
          <Route exact path="/" component={Login} key={'login'} />
          <Route exact path="/report/:uuid" component={Report} key={'report'}/>
          <Route exact path="/reportcar/:uuid" component={ReportCar} key={'reportcar'}/>
          <Route path="/record" component={Record} key={'record'}/>
          <Route path="/download" component={Download} key={'download'} />
          <Route path="/person/PersonRegist" component={PersonRegist} key={'personregist'} />
          <Route path="/person/PersonCenter" component={PersonCenter} key={'personcenter'} />
          <Route path="/person/QuestionList" component={QuestionList} key={'questionlist'} />
          <Route path="/person/QuestionDetail" component={QuestionDetail} key={'questionDetail'} />
          <Route path="/person/reward/Reward" component={Reward} key={'reward'} />
          <Route path="/person/reward/RewardJs" component={RewardJs} key={'rewardJs'} />
          <Route path="/person/reward/Devicebuy" component={Devicebuy} key={'devicebuy'} />
          <Route path="/person/message/MessageList" component={MessageList} key={'messagelist'} />
          <Route path="/person/message/MessageDetail" component={MessageDetail} key={'messageDetail'} />
          <Route path="/person/DeviceInfomation" component={DeviceInfomation} key={'deviceinfomation'} />
          <Route path="/person/ShowResult" component={ShowResult} key={'showResult'} />
          <Route path="/person/FaultPost" component={FaultPost} key={'faultPost'} />
          <Route path="/person/Suggestion" component={Suggestion} key={'suggestion'} />
          <Route path="/person/pay/Shop" component={Shop} key={'shop'} />
          <Route path="/advert" component={Advert} key={'advert'} />         
        </div>
      </Router>
      </Provider>
    
    );
  }
}
export default App;


// WEBPACK FOOTER //
// ./src/App.js